import store from '@/store'

export default {
    getMatchedAccessRights(currentPath) {
        if (!store.state.user_apps_list) return []
        for (const item of store.state.user_apps_list) {
            const match = item.appPages.filter(x => currentPath.startsWith(x.pagePath))
            if (match.length) return match
        }
        return []
    },
    hasEditRights(currentPath) {
        const matched = this.getMatchedAccessRights(currentPath)
        return matched.length > 0 && matched[0].accessRights.edit === true
    },
    hasApproverRights(currentPath) {
        const matched = this.getMatchedAccessRights(currentPath)
        return matched.length > 0 && matched[0].accessRights.approver === true
    },
}
